import { FC, ReactNode } from 'react';
import { IconButton } from '../../../core-components/IconButton';
import { DataRow, RowItem } from '../../shared/DataRow';

export type FlightLegDetailsProps = {
  headline?: ReactNode;
  content?: ReactNode;

  dataRows?: RowItem[];

  infoHeadline?: ReactNode;
  infoContent?: ReactNode;

  onBack?: () => void;
};

export const FlightLegDetails: FC<FlightLegDetailsProps> = ({
  headline,
  content,
  dataRows,
  infoHeadline,
  infoContent,
  onBack,
}) => {
  return (
    <div className="flex flex-col gap-8 p-6 text-marine-high-emphasis">
      <IconButton iconName="arrow-left" variant="secondary" onClick={onBack} />
      <div className="space-y-2">
        {headline && <h3 className="headline-lg">{headline}</h3>}
        {content && <p>{content}</p>}
      </div>
      <div>
        {dataRows?.map((props, index) => (
          <DataRow key={index} {...props} />
        ))}
      </div>
      <div className="space-y-2">
        {infoHeadline && <h4 className="headline-sm">{infoHeadline}</h4>}
        {infoContent && <p className="info-md">{infoContent}</p>}
      </div>
    </div>
  );
};
